import { TestStatus } from "../../api/types";
import { TestSearchResult } from "../../types";
import { formatDate } from "../../utils";
import RadioButton from "../../components/RadioButton";
import { twMerge } from "tailwind-merge";

const STATUSES_TEXT = {
    [TestStatus.COMPLETED]: "Completed",
    [TestStatus.NOT_COMPLETED]: "Not Completed",
};

export const TestSearchResultRow = ({
    result,
    index,
    isSelected,
    disabled,
    onSelect,
    isMultipleSelect = false,
    warning,
}: {
    result: TestSearchResult;
    index: number;
    isSelected: boolean;
    disabled?: boolean;
    onSelect: (testId: number) => void;
    isMultipleSelect?: boolean;
    warning?: string;
}) => {
    return (
        <tr
            onClick={() => {
                if (disabled) return;
                if (warning) {
                    window.confirm(warning) && onSelect(result.testId);
                } else {
                    onSelect(result.testId);
                }
            }}
            className={twMerge(
                index % 2 === 0 ? "bg-white" : "bg-gray-light",
                `h-9 xl:h-12 px-4 cursor-pointer text-sm xl:text-base`,
                disabled && "opacity-40 grayscale cursor-not-allowed"
            )}
            key={result.testId}
        >
            <td>
                <div className="flex items-center justify-center">
                    <RadioButton
                        label=""
                        checked={isSelected}
                        onChange={() => {}}
                        isSquared={isMultipleSelect}
                    />
                </div>
            </td>
            <td>{`${result.firstName} ${result.lastName}`}</td>
            <td>{result.personId}</td>
            <td>{formatDate(result.testDate)}</td>
            <td>{STATUSES_TEXT[result.status]}</td>
        </tr>
    );
};

export default TestSearchResultRow;
